<div class="basket-charges" id="basket-charges" *ngIf="basket?.Charges">
  <div class="basket-charge-total" *ngIf="!showErrorsOnly">
    <div class="basket-charge-list-item" *ngIf="minimumSpendSurcharge">
      <span>Minimum Spend</span>
      <samp>£{{ parseFormatNumber(minimumSpendSurcharge) | StringToMoneyFilter}}</samp>
    </div>
  
    <div class="basket-charge-list-item">
      <span>Subtotal</span>
      <samp *ngIf="subTotalIncludingTax && subTotalIncludingTax !== 0">{{ subTotalIncludingTax | currency:'GBP'}}</samp>
      <samp *ngIf="!subTotalIncludingTax || subTotalIncludingTax === 0">{{ basketSubTotal + basketTax | currency:'GBP' }}</samp>
    </div>
  
    <div class="basket-charge-list-item" *ngIf="basketDeliveryCharge > 0">
      <span>Delivery Fee</span>
      <samp>£{{ parseFormatNumber(basketDeliveryCharge) | StringToMoneyFilter}}</samp>
    </div>

    <div class="basket-charge-list-item" *ngIf="loyaltyDiscount > 0">
      <span>Loyalty Discount</span>
      <div class="basket-charge-list-item-group">
        <samp>-{{ loyaltyDiscount | currency:'GBP' }}</samp>
        <mat-icon class="delete-icon" (click)="removeLoyalty()" *ngIf="!orderComplete">delete_forever</mat-icon>
      </div>
    </div>

    <div class="basket-charge-list-item" *ngIf="basket.VoucherCode && (!basket.UnlockedProductIds || basket.UnlockedProductIds?.length === 0)">
      <span>{{ voucherNarrative }}</span>
      <div class="basket-charge-list-item-group">
        <samp>{{ voucherPrice | currency: 'GBP' }}</samp>
        <mat-icon class="delete-icon" (click)="removeVoucher()" *ngIf="!orderComplete">delete_forever</mat-icon>
      </div>
    </div>

    <div class="basket-charge-list-item basket-total" *ngIf="basketTotal > 0">
      <span>Total</span>
      <samp>£{{ basketTotal || 0 | StringToMoneyFilter }}</samp>
    </div>
  </div>

  <div class="basket-charge-errors" *ngIf="basketIssues?.length > 0">
    <ng-container *ngFor="let issue of basketIssues">
      <span>{{ issue }}</span>
    </ng-container>
  </div>
</div>
